import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, NavigationEnd, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { TranslocoService } from '@jsverse/transloco';
import { delay, filter, switchMap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RouteTitleTranslateService {
  constructor(
    private readonly router: Router,
    private readonly title: Title,
    private readonly transloco: TranslocoService,
  ) {}

  init() {
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        delay(0),
      )
      .subscribe(() => this.updateTitle());

    this.transloco.langChanges$
      .pipe(switchMap(lang => this.transloco.load(lang)))
      .subscribe(() => this.updateTitle());
  }

  private updateTitle() {
    const route = this.getDeepestTitle(this.router.routerState.snapshot.root);
    if (!route?.title) {
      return;
    }

    const translated = this.transloco.translate(route.title);
    this.title.setTitle(translated);
  }

  private getDeepestTitle(
    route: ActivatedRouteSnapshot,
  ): ActivatedRouteSnapshot {
    while (route.firstChild) {
      route = route.firstChild;
    }
    return route;
  }
}
